export default "__VITE_ASSET__59f7902f__"